import React, { useMemo } from 'react'
import DatePicker from 'react-datepicker'
import id from 'date-fns/locale/id'
import 'react-datepicker/dist/react-datepicker.css'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const InputRangeDatePicker = ({
  startDate,
  endDate,
  onCallback,
  initial,
  required,
  radius,
  changeYear,
  disabled,
  preventManuallyType,
}) => {
  const { t } = useTranslation()
  // Batas Minimal: 1 Januari 2022
  const minLimit = new Date(2022, 0, 1)
  // Batas Maksimal: Hari ini
  const maxLimit = new Date()

  const config = useMemo(() => {
    let baseConfig = {
      dateFormat: 'dd MMMM yyyy',
      showYearDropdown: changeYear,
      dropdownMode: changeYear ? 'select' : undefined,
    }

    if (initial === 'YY') {
      baseConfig = { ...baseConfig, dateFormat: 'yyyy', showYearPicker: true }
    } else if (initial === 'MMYY') {
      baseConfig = { ...baseConfig, dateFormat: 'MMMM yyyy', showMonthYearPicker: true }
    }

    return baseConfig
  }, [initial, changeYear])

  const onChange = (dates) => {
    onCallback(dates)
  }

  const preventManual = (e) => {
    if (preventManuallyType) e.preventDefault()
  }

  return (
    <div className="d-flex align-items-center w-100">
      <div className="flex-grow-1">
        <DatePicker
          locale={id}
          selected={startDate}
          onChange={(date) => onChange({ start: date, end: endDate })}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          minDate={minLimit}
          maxDate={maxLimit}
          required={required}
          placeholderText={t('field_input.select_start_date')}
          className={`form-control ${radius}`}
          disabled={disabled}
          onKeyDown={preventManual}
          {...config}
        />
      </div>

      <span className="mx-2 text-black-50 small text-nowrap">s/d</span>

      <div className="flex-grow-1">
        <DatePicker
          locale={id}
          selected={endDate}
          onChange={(date) => onChange({ start: startDate, end: date })}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate || minLimit} // Tidak boleh sebelum startDate
          maxDate={maxLimit}
          required={required}
          placeholderText={t('field_input.select_end_date')}
          className={`form-control ${radius}`}
          disabled={disabled || !startDate}
          onKeyDown={preventManual}
          {...config}
        />
      </div>
    </div>
  )
}

InputRangeDatePicker.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  onCallback: PropTypes.func.isRequired,
  initial: PropTypes.string,
  required: PropTypes.bool,
  radius: PropTypes.string,
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.bool]),
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.bool]),
  changeYear: PropTypes.bool,
  disabled: PropTypes.bool,
  preventManuallyType: PropTypes.bool,
}

export default InputRangeDatePicker
